import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit,ChangeDetectorRef } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ColDef, CellStyle, ExcelExportParams, GridReadyEvent, ISetFilterParams, themeQuartz, ValueFormatterParams } from 'ag-grid-community';  
import { formatDate } from 'src/app/shared/commen-function-file';
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { formatText } from 'src/app/shared/commen-function-file';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { calculateFiscalYear, formatYearRanges } from 'src/app/shared/commen-function-file';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { CommentDialogComponent } from 'src/app/shared/comment-dialog/comment-dialog.component';

interface AssetNode {
  id: any;
  assetName: string;
  children?: AssetNode[];
}
export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD-MM-YYYY'
  },
  display: {
    dateInput: 'DD-MM-YYYY',
    monthYearLabel: 'MMMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
}

@Component({
  selector: 'app-asset-employee-edit',
  templateUrl: './asset-employee-edit.component.html',
  styleUrls: ['./asset-employee-edit.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' }, // Use en-GB to get DD/MM/YYYY format
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS },
  ],
})
export class AssetEmployeeEditComponent implements OnInit {
  buttonColorName: any;
  updateData: any;
  userListDataForAsset: any;
  dropdownSettingsForBand: IDropdownSettings = {};
  dropdownSettingsForAsset: IDropdownSettings = {};
  dropdownSettingsForEmployee: IDropdownSettings = {};
  selectedAsset: any;
  selectedEmployee: any;
  selectedSubAsset: any;
  filteredEmployees: any[] = [];
  filteredAssets: any[] = [];
  selectedBand: any[] = [];
  selectedAssets: any[] = [];
  allAssets: string[] = [];
  assets: any = [];
  allUsers: any[] = [];
  AllAssetListingData: any[] = [];
  originalAssets: any[] = [];
  dropDownForband: any[] = [];
  dropDownForEmployee: any[] = [];
  finalTableListData: any[] = [];
  // updatedAssetData: Asset[] = [];
  updatedAssetData: any[] = [];

  selectedEmployeeIdForReport: any;
  dropdownData: any;
  loggedInUserCompanyID: any;
  loggedInCompanyFiscalyear: any | null;
  loggedInUserId: any | null;
  year: any;
  fiscalYear: any;
  todayDate: any;
  datedisplay: any
  isReadOnly = true;
  loggedInUserRole: any | null;
  loggedInCompanyMDCode: any | null;
  loggedInCompanyReviewCycle: any | null;
  loggedInUserRoles: any;
  loggedInUserName: any;
  forAuthority: any
  selectedTab: any;
  findLogdinUserAsaAuthority: any = false;
  assetsList: any;
  


  constructor(private datePipe: DatePipe, public dialogRef: MatDialogRef<AssetEmployeeEditComponent>, public dialog: MatDialog, private toastr: ToastrService, public mobileResponsiveService: MobileResponsiveService,
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService,private cdRef: ChangeDetectorRef, private config: Config, private httpService: HttpService,) {
    this.todayDate = new Date().toISOString().split('T')[0];
    this.datedisplay = this.datePipe;
    this.year = data?.year;
    this.fiscalYear = data?.fiscal_year;
    this.updateData = data?.data;
    this.forAuthority = data?.authority;
    this.selectedTab = data?.selectedTab;
    this.assetsList = data?.assets;

    if (this.data?.data != null) {
      this.selectedBand = this.updateData?.band;
      this.selectedEmployee = this.updateData?.employeeName;
      //  this.selectedAssets = this.updateData?.assetId;
    }
  }
  assetOptionsForEmployee = [
    "RECEIVED_ASSET",
    "REPAIR_ASSET",
    "RETURNING_ASSET_DUE_TO_EXIT",
    "RECEIVED_AFTER_REPAIR"
  ];

  assetOptions: string[] = [
    'ASSET_GIVEN',
    'ASSET_REPAIRED',
    'RECEIVED_AFTER_EXIT',
    'NOT_RECEIVED_AFTER_EXIT',
    'IN_PROGRESS',
    'OTHER_REASON'
  ];

  ngOnInit() {
    
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.findLogdinUserAsaAuthority = sessionStorage.getItem('findLogdinUserAsaAuthority');
    this.loggedInCompanyMDCode = sessionStorage.getItem('loggedInCompanyMDCode');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.loggedInUserRoles = JSON.parse(sessionStorage.getItem('loggedInUserRoles') || '[]');
    this.loggedInCompanyReviewCycle = sessionStorage.getItem('loggedInCompanyReviewCycle') || null;
    this.buttonColorName = sessionStorage.getItem('buttonColorName');


    this.getAllaseetListingData();
    this.assetAllocationData();


    // this.allAssets = this.userListDataForAsset.users.map((asset: { assetName: any; }) => asset.assetName);

    this.dropdownSettingsForBand = {
      singleSelection: false,
      idField: 'id',
      textField: 'band',

      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForAsset = {
      singleSelection: true,
      idField: 'assetId',
      textField: 'asset',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true,

    };
    this.dropdownSettingsForEmployee = {
      singleSelection: false, // or true if only one selection is allowed
      idField: 'userId',      // Key for unique IDs
      textField: 'employeName', // Key for displayed text
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 3,
      allowSearchFilter: true, // Enable search functionality
    };

    this.buildColumnDefs();

  }

  formatedataVariable = formatText;
  strFormatDate = formatDate;

  
  // --------------------------------AG GRID CODE---------------------------------------------------------
  gridApi: any;
  paginationPageSizeSelector = [5, 10, 20, 50, 100, 200, 500, 1000];
  pagination = true;
  paginationPageSize = 10;
  detailRowAutoHeight = true;

  defaultColDef: ColDef = {
    flex: 1,
    minWidth: 100,
    filter: true,
    resizable: true,
    sortable: true,
    floatingFilter: false,  // ✅ small filter box under header
  };

  gridOptions: any = {
    defaultColDef: {
      resizable: true,    // ✅ columns resize ho sakte hain
      sortable: true,  // ✅ sorting enable
      filter: true,  // ✅ filtering enable
      floatingFilter: true, // ✅ filters ki input box top me
      minWidth: 80,
      // ✅ rowIndex ke base pe alternate row styling (zebra effect)
      cellClass: (p: any) =>
        p.node.rowIndex % 2 === 0 ? 'cell-even' : 'cell-odd'
    },
    context: { componentParent: this },  // ✅ agar component method call karna ho renderer/formatter se
    rowSelection: 'single',     // ✅ single row select
    singleClickEdit: true,       // ✅ click = edit (Pending wale case me helpful)
    stopEditingWhenCellsLoseFocus: true,    // ✅ focus lose hote hi editing stop
    // ✅ jab bhi cell update hoga, ye call hoga
    // onCellValueChanged: (event: any) => this.onCellValueChanged(event)
    localeText: {
      noRowsToShow: 'No Data Found'  // default text ko replace karna hai 'No Rows To Show' to 'No Data Found'
    }
  };

  onCellValueChanged(event: any) {
     const field = event.colDef.field;
     console.log("--------calue--", field)
    if (field === 'employeeComment' && event.newValue?.length > 255) {
      // Trim value
      event.node.setDataValue(field, event.newValue.substring(0, 255));

      // 🔔 Built-in AG Grid notification using its internal API
      event.api.showOverlay('LoadingOverlay'); // show overlay temporarily
      setTimeout(() => event.api.hideOverlay(), 1000);

      // Or more commonly, use AG Grid's built-in console logger style
      event.api.gridBodyCtrl.gridOptionsWrapper.getGridOptions().api.showNoRowsOverlay = () => {
        console.warn('Maximum 255 characters allowed!');
      };

      // Or just console
      console.warn('Maximum 255 characters allowed!');
    }
    this.updatedAssetData.push(event.data);
  }
 



  openCommentModal(text: string, commentType: any) {
    this.dialog.open(CommentDialogComponent, {
      width: '600px',
      data: {
        text: text,
        commentType: commentType
      }
    });

  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    params.api.sizeColumnsToFit();
    console.log(params)
  }
  formatStatus(value: any): string {
    if (!value || typeof value !== 'string') {
      return 'N/A'; // fallback agar value string na ho
    }

    // Camel Case → Title Case
    return value
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
  formatDate(value: any): string {
    if (!value) return 'N/A';

    const date = new Date(value);
    if (isNaN(date.getTime())) return 'Invalid Date';

    // dd-MM-yyyy format
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }

  // ✅ Global search function
  onFilterTextBoxChanged(value: string = '') {
    if (!this.gridApi) return;

    // v31+ way:
    this.gridApi.setGridOption('quickFilterText', value ?? '');

  }
  onBtExport() {
    const params: ExcelExportParams = {
      fileName: 'Expense_Report_' + new Date().toISOString().slice(0, 10) + '.xlsx',
      sheetName: 'ExpenseData',
      exportAsExcelTable: {
        showRowStripes: true,
        name: 'ExpenseTable'
      },
      processCellCallback: (cell) => {
        const header = cell.column.getColDef().headerName;
        const value = cell.value;

        // 1. Date Formatting (for specific headers)
        const dateColumns = ['date', 'dateOfExpense']; // <- field names ya headerName use karo

        if (dateColumns.includes(cell.column.getColId()) && cell.value) {
          const date = new Date(cell.value);
          if (!isNaN(date.getTime())) {
            return (
              ('0' + date.getDate()).slice(-2) +
              '-' +
              ('0' + (date.getMonth() + 1)).slice(-2) +
              '-' +
              date.getFullYear()
            );
          }
        }

        // 2. Status Formatting (make it human readable)
        if (header === 'Status' && value) {
          return value
            .toString()
            .toLowerCase()
            .replace(/_/g, ' ') // replace underscores with space
            .replace(/\b\w/g, (char: any) => char.toUpperCase()); // capitalize each word
        }

        return value;
      }
    };

    this.gridApi.exportDataAsExcel(params);
  }


  approvalRenderer(params: any) {
    if (!params.value) return '';
    const status = params.value.toUpperCase();

    let color = '';
    if (status === 'APPROVED') {
      color = '#4caf50'; // green
    } else if (status === 'REJECTED') {
      color = '#f44336'; // red
    } else if (status === 'PENDING') {
      color = '#ff9800'; // orange
    }

    return `
          <span style="
            border: 1px solid ${color};
            color: ${color};
            padding: 4px 10px;
            border-radius: 12px;
            font-size: 12px;
            font-weight: 500;
            display: inline-block;
            line-height: 20px;
            white-space: nowrap;
          ">
        ${status.charAt(0) + status.slice(1).toLowerCase()}
      </span>
    `;
  }

 


  

  statusFormatter(params: any): string {
    if (!params.value) return '';

    const valueUpper = params.value.toUpperCase();

    // 🔹 Status → Color map
    const statusColors: Record<string, string> = {
      'APPROVED_BY_FINANCE_BUT_NOT_PAID': '#4caf50', // green
      'APPROVED_BY_MANAGER_SENT_TO_FINANCE': '#4caf50',
      'APPROVED_BY_MANAGER_REJECTED_BY_FINANCE': '#f44336', // red
      'APPROVED_BY_HR_ADMIN_SENT_TO_FINANCE':'#126d79',
      'APPROVED_BY_MANAGER_SENT_TO_HR_ADMIN':'#3939ece8',
      'REJECTED_BY_MANAGER': '#f44336',
      'PENDING_WITH_MANAGER': '#ff9800', // orange
      'REJECTED_BY_HR_ADMIN':'#f44336'
    };

    // 🔹 Default color = grey
    const color =
      Object.keys(statusColors).find(key => valueUpper.includes(key))
        ? statusColors[
        Object.keys(statusColors).find(key => valueUpper.includes(key))!
        ]
        : '#999';

    // 🔹 Convert to Title Case
    const formattedText = params.value
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    return `
      <span style="
        border: 1px solid ${color};
        color: ${color};
        padding: 4px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 500;
        display: inline-block;
        white-space: normal;
        word-wrap: break-word;
        line-height: 1.4em;
        animation: fadeInScale 0.3s ease-in-out;
        max-width: 100%;
      ">
        ${formattedText}
      </span>
    `;
  }

  dateRenderer(params: any) {
    if (!params.value) return '';
    const date = new Date(params.value);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  dateComparator(valueA: string, valueB: string) {
    const parseDate = (value: string) => {
      if (!value) return null;
      // Agar backend se yyyy-mm-dd aa raha hai:
      if (value.includes('-') && value.indexOf('-') === 4) {
        return new Date(value).getTime();
      }
      // Agar already dd-mm-yyyy format hai:
      const [day, month, year] = value.split('-').map(Number);
      return new Date(year, month - 1, day).getTime();
    };

    const dateA = parseDate(valueA);
    const dateB = parseDate(valueB);

    if (dateA === dateB) return 0;
    if (dateA == null) return -1;
    if (dateB == null) return 1;
    return dateA - dateB;
  }

  openFile(fileUrl: string) {
    window.open(fileUrl, '_blank');
  }
  downloadRenderer = (params: any) => {

    const fileUrl = `${this.config.downloadFile}${params.value}`;
    if (!params.value) return '';
    const img = document.createElement('img');
    img.src = 'assets/icon/yellowdownload.png'; // replace with your icon path
    img.alt = 'download';
    img.style.width = '18px';
    img.style.height = '18px';
    img.style.cursor = 'pointer';
    img.title = params.value;
    img.addEventListener('click', (e) => {
      e.stopPropagation();
      // open file in new tab
      window.open(fileUrl, '_blank');
    });
    return img;
  }

  downloadDialogRenderer(fileName: string): string {
    if (!fileName) return '';
    return `${this.config.downloadFile}${fileName}`;
  }
  selectedRow: any;
  isDetailsOpen = false;
  onRowClicked(event: any) {
     console.log('HR Admin Row Clicked:', event.data);
    this.selectedRow = event.data;
    console.log("selected row iss333...", this.selectedRow )
    //  this.isDetailsOpen = true;
  }
// For HR Admin
selectedRowForHrAdmin:any;

onRowClickedForHRAdmin(event: any) {
  console.log('HR row click -> data:', event.data);
  this.selectedRowForHrAdmin = event.data;
  // You can decide whether show detail on row click or only on cell click
   this.isDetailsOpenForHRAdmin = true;
}


  //Employe Login 
  onRowClickedForEmployee(event: any) {
    console.log('Clicked Column:**', event.colDef);
    this.selectedRow = event.data;
    if (event.colDef?.field === 'action') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
    }
  }
  onCelledClicked(event: any) {
    console.log("field is..............",event);
    
    this.selectedRow = event.data;
    console.log("selected row iss...", this.selectedRow )
    // sirf managerComment ya approvedByManager pe hi details open kare
    if (event.colDef?.field === 'managerComment' || event.colDef?.field === 'approvedByManager'  || event.colDef?.field === 'approvedByHrAdmin') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
      this.cdRef.detectChanges();
    }
  }
//For Hr Admin
isDetailsOpenForHRAdmin = false;
onCelledClickedForHRAdmin(event: any) {
  console.log('HR cellClicked field:', event.colDef?.field, 'data:', event.data);
  this.selectedRowForHrAdmin = event.data;

  // If you want to avoid opening for certain fields (mirrors your existing logic)
  if (event.colDef?.field === 'approvedByHrAdmin') {
    this.isDetailsOpenForHRAdmin = false;
  } else {
    this.isDetailsOpenForHRAdmin = true;
    this.cdRef.detectChanges();
  }
}

closeDetailsForHrAdmin() {
  this.isDetailsOpenForHRAdmin = false;
}
  // For Finance Login
  onCelledFinanceClicked(event: any) {

    this.selectedRow = event.data;

    // sirf financeComment ya assignedAmount pe hi details open kare
    if (event.colDef?.field === 'financeComment' || event.colDef?.field === 'assignedAmount' || event.colDef?.field === 'financeStatus') {
      this.isDetailsOpen = false;
    } else {
      this.isDetailsOpen = true;
    }
  }
  closeDetails() {
    this.isDetailsOpen = false;
  }

  isClicked = false;


  resetGrid() {
    this.isClicked = true; // Trigger animation

    if (this.gridApi) {
            
      // ✅ Reset filters & sorting
      this.gridApi.setFilterModel(null);
      // this.gridApi.setSortModel(null);
      this.gridApi.deselectAll();

      // ✅ Reset quick filter (search box)
      
      this.gridApi.setGridOption('quickFilterText', ''); // Clears quick filter text

      // ✅ Reset pagination
      this.paginationPageSize = 10;
      this.gridApi.setGridOption('paginationPageSize', this.paginationPageSize);
      this.gridApi.paginationGoToFirstPage();

      // ✅ Force refresh so UI input also clears
      this.gridApi.refreshCells();
      this.gridApi.resetColumnState();         // ✅ Reset columns
    }
  }


  // --------------------------------AG GRID CODE---------------------------------------------------------
    columnDefs: ColDef[] = [];
  buildColumnDefs() {
     
  this.columnDefs = [
  {
    headerName: 'Asset',
    field: 'assetName',
    minWidth: 150
  },
  {
    headerName: 'Employee Name',
    field: 'employeeName',
    minWidth: 180
  },
  {
    headerName: 'Band',
    field: 'band',
    minWidth: 120
  },
  {
    headerName: 'Allocating Dept',
    field: 'allocatingAuthorityDept',
    minWidth: 180
  },
  {
    headerName: 'Authority Name',
    field: 'allocatingAuthorityName',
    minWidth: 180
  },
  {
    headerName: 'Allocation Date',
    field: 'dateOfAllocation',
    minWidth: 180,
    editable: false,
    cellRenderer: (params: any) => this.dateRenderer(params),
    comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
    filter: 'agDateColumnFilter',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    filterParams: {
      filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
      suppressAndOrCondition: true,  // ✅ AND/OR hide
      maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
    }
  },
 {
  headerName: 'Current Asset Description',
  field: 'currentAssetDescription',
  cellEditor: 'agLargeTextCellEditor',
  cellEditorParams: { maxLength: 255, rows: 3, cols: 30 },
  minWidth: 300,

  wrapHeaderText: true,
  autoHeaderHeight: true,
  editable: (params: any) => {
    const role = params.context.componentParent.loggedInUserRole;
    const selectedTab = params.context.componentParent.selectedTab;

    // 🔒 Disable if user is Employee, HR Admin, Super Admin, or tab = 'Asset'
    if (
      role === 'employee' ||
      role === 'HR Admin' ||
      role === 'Super Admin' ||
      selectedTab === 'Asset'
    ) {
      return false; // not editable
    }

    return true; // editable otherwise
  },
  cellStyle: (params): CellStyle | null => {
    const role = params.context.componentParent.loggedInUserRole;
    const selectedTab = params.context.componentParent.selectedTab;
  
    const isEditable =
      role !== 'employee' &&
      role !== 'HR Admin' &&
      role !== 'Super Admin' &&
      selectedTab !== 'Asset';
  
    if (isEditable) {
      return {
        backgroundColor: '#f5edee5e',
        fontWeight: '600'
      };
    }
  
    return null; // ✅ valid return, no TypeScript error
  },
  
}
,
  {
      headerName: 'Employee Status',
      field: 'employeeAssetStatus',

      editable: (params) => {
        console.log("params iss...",params);
        const role = params.context.componentParent.loggedInUserRole;
        const isAuth = params.context.componentParent.findLogdinUserAsaAuthority; // "false" or "true"
        const selectedTab = params.context.componentParent.selectedTab;
        console.log("selectedTab iss.isAuth------------------..",isAuth);

          if (role === 'employee' ||
            selectedTab === 'Asset'
          ) {
            return true; // not editable
          }

          return false; // editable otherwise
          
        // return (
        //   selectedTab === 'Asset' ||
        //   (role == 'Manager')
        // );
      },

      cellEditor: 'agSelectCellEditor',
      cellEditorParams: (params:any) => ({
        
        values: params.context.componentParent.assetOptionsForEmployee
      }),

      valueFormatter: (params) =>
        params.value ? params.context.componentParent.formatedataVariable(params.value) : '',

      minWidth: 300,

      /** ✅ Correct, typed cellStyle function */
      cellStyle: (params): CellStyle => {
        const role = params.context.componentParent.loggedInUserRole;
        const isAuth = params.context.componentParent.findLogdinUserAsaAuthority;
        const selectedTab = params.context.componentParent.selectedTab;

        const editable = selectedTab === 'Asset' || role === 'employee' 
      return editable
        ? { backgroundColor: '#e8f5e9', fontWeight: '600', color: '#0a0a0a' }
        : { backgroundColor: '#ffffff', color: '#000000' };
      },

      // headerTooltip: 'HR ADMIN / Allocating Authority Comment',
      wrapHeaderText: true,
      autoHeaderHeight: true
    },{
  headerName: 'Employee Comment',
  field: 'employeeComment',
  editable: (params: any) => {
    const role = params.context.componentParent.loggedInUserRole;
    const isAuth = params.context.componentParent.findLogdinUserAsaAuthority;
    const selectedTab = params.context.componentParent.selectedTab;
  
    return !(
      role === 'HR Admin' ||
      role === 'Super Admin' ||
      (isAuth && role !== 'Employee' && role !== 'Manager' && role !== 'HOD') ||
      selectedTab === 'Inventory'
    );
  },
  cellStyle: (params): any => {
    const role = params.context.componentParent.loggedInUserRole;
    const isAuth = params.context.componentParent.findLogdinUserAsaAuthority;
    const selectedTab = params.context.componentParent.selectedTab;
  
    const isEditable = !(
      role === 'HR Admin' ||
      role === 'Super Admin' ||
      (isAuth && role !== 'Employee' && role !== 'Manager' && role !== 'HOD') ||
      selectedTab === 'Inventory'
    );
  
    if (!isEditable) return null;
    return { backgroundColor: '#f5edee5e', fontWeight: '600' };
  },
  cellEditor: 'agLargeTextCellEditor',
  cellEditorParams: { maxLength: 255, rows: 3, cols: 30 },
  tooltipField: 'employeeComment', // ✅ show value as tooltip
  minWidth: 300,
}
 ,
  {
    headerName: 'Employee Comment Date',
    field: 'employeeCommentDate',
    minWidth: 220,
    editable: false,
    cellRenderer: (params: any) => this.dateRenderer(params),
    comparator: (valueA: string, valueB: string) => this.dateComparator(valueA, valueB),
    filter: 'agDateColumnFilter',
    wrapHeaderText: true,
    autoHeaderHeight: true,
    filterParams: {
      filterOptions: ['equals', 'inRange', 'blank', 'notBlank'],
      suppressAndOrCondition: true,  // ✅ AND/OR hide
      maxNumConditions: 1            // ✅ Sirf ek condition allow hogi
    }
  },
  {
  headerName: 'HR ADMIN/Allocating Authority Comment',
  field: 'authorityDepartmentComment',

  editable: (params) => {
    const role = params.context.componentParent.loggedInUserRole;
    const isAuth = params.context.componentParent.findLogdinUserAsaAuthority; // "false" or "true"
    const selectedTab = params.context.componentParent.selectedTab;

    return !(
      selectedTab === 'Asset' ||
      (isAuth == 'false' && role !== 'HR Admin')
    );
  },

  cellEditor: 'agSelectCellEditor',
  cellEditorParams: (params:any) => ({
    values: params.context.componentParent.assetOptions
  }),

  valueFormatter: (params) =>
    params.value ? params.context.componentParent.formatedataVariable(params.value) : '',

  minWidth: 350,

  /** ✅ Correct, typed cellStyle function */
  cellStyle: (params): CellStyle => {
    const role = params.context.componentParent.loggedInUserRole;
    const isAuth = params.context.componentParent.findLogdinUserAsaAuthority;
    const selectedTab = params.context.componentParent.selectedTab;

    const editable =
      !(
        selectedTab === 'Asset' ||
        (isAuth == 'false' && role !== 'HR Admin')
      );

    // Return style object
    if (editable) {
      return {
        backgroundColor: '#e8f5e9',
        fontWeight: '600',
        color: '#0a0a0a'
      };
    } else {
      return {
        backgroundColor: '#fffffff',
        color: '#000000'
      };
    }
  },

  headerTooltip: 'HR ADMIN / Allocating Authority Comment',
  wrapHeaderText: true,
  autoHeaderHeight: true
},
  {
    headerName: 'Authority Comment Date',
    field: 'authorityCommentDate',
    minWidth: 300,
    
  }
];

  }
  // ---------------------------------------------------------------------------
  // Event Handlers
  onSelectSingleSelectFilterReport(event: any) {
    this.groupEmployees();
  }

  selectAllEmpForReport(event: any) {

    this.selectedAssets = [...event];
    this.groupEmployees();
  }

  onDeSelectAllEmpForReport(event: any) {
    this.selectedAssets = [];
    this.groupEmployees();
  }




  // Triggered when the asset dropdown is clicked
  onAssetClick() {

    // You can handle other logic when dropdown is clicked, if needed
  }

  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = formatYearRanges(data?.data?.yearRanges);

  //     const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

  //     const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  //     this.setSelectedYear(yearValue);

  //   });
  // }
  // setSelectedYear(yearValue: string): void {
  //   const selectedYearObj = this.pmsYears.find((ele: any) => ele.year === yearValue);
  //   if (selectedYearObj) {
  //     this.selectedYearForCompetency = selectedYearObj?.year;
  //         // this.selectedYearForGraphOneHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphTwoHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphFifthHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphSix = selectedYearObj?.year;
  //         // this.selectedYearForGraphNineHRAdmin = selectedYearObj?.year;
  //         // this.selectedYearForGraphTenHRAdmin = selectedYearObj?.year;

  //     let test = selectedYearObj?.year.split('-');
  //     this.fromYear = test[0];
  //     this.toYear = test[1];
  //   }
  // }




  assetManagementHeader = [
    { label: 'Asset', isMandatory: true, sortingName: 'asset' },
    { label: 'Employee Name', isMandatory: true, sortingName: 'employeeName' },
    { label: 'Band', isMandatory: true, sortingName: 'band' },
    { label: 'Allocating Dept', isMandatory: true, sortingName: 'allocatingAuthorityDept' },
    { label: 'Authority Name', isMandatory: true, sortingName: 'allocatingAuthorityName' },
    { label: 'Allocation Date', isMandatory: true, sortingName: 'reimbursementType' },
    { label: 'Current Asset Description', isMandatory: true, sortingName: 'startDate' },
    { label: 'Employee Status', isMandatory: true, sortingName: 'startDate' },
    { label: 'Employee Comment', isMandatory: true, sortingName: 'reimbursementType' },
    { label: 'Employee Comment Date', isMandatory: true, sortingName: 'startDate' },

    { label: 'HR ADMIN/Allocating Authority Comment', isMandatory: true, sortingName: 'reimbursementLimit' },
    { label: 'Authority Comment Date', isMandatory: true, sortingName: 'actualAmount' },

  ];





  getAllaseetListingData() {
    this.httpService.callGetService(`${this.config.getAssetListingAll}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
        this.AllAssetListingData = elm.data;



      })

  }





  assetAllocationData() {
    this.httpService.callGetService(`${this.config.assetAllocation}/${this.loggedInUserCompanyID}/${this.fiscalYear}/${this.year}`)
      .subscribe((elm: any) => {
       

        this.originalAssets = elm.data;
        console.log("asset list...",   this.originalAssets);

        this.groupEmployees();

      })

  }






  groupEmployees() {
    // Initialize an empty array to hold all users
    this.allUsers = [];

    // Loop through the original assets and collect all user details
    for (const asset of this.originalAssets) {
      this.allUsers.push({
        id: asset.id,
        employeeName: asset.employeeName,
        employeeComment: asset.employeeComment,
        employeeCommentDate: asset.employeeCommentDate,
        employeeAssetStatus: asset.employeeAssetStatus,
        allocatingAuthorityName: asset.authorityName,
        allocatingAuthorityDept: asset.authorityDepartment,
        employeeEmail: asset.employeeEmail,
        authorityEmail: asset.authorityEmail,
        assetName: asset.assetName,
        band: asset.band,
        userId: asset.userId,
        assetId: asset.assetId,
        dateOfAllocation: asset.dateOfAllocation,
        currentAssetDescription: asset.currentAssetDescription,
        authorityCommentDate: this.strFormatDate(asset.authorityCommentDate),
        authorityDepartmentComment: asset.authorityDepartmentComment
      });
    }
      

    const specificAsset = this.assetsList.map((asset: any) => {
      return {
        assetName: asset.assetName,
        band: asset.band,

      };
    });

    const list = {
      assetData: specificAsset,
      users: this.allUsers
    }
      
    if (this.updateData != null) {
      this.userListDataForAsset = list;
      
      if (this.forAuthority === 'From Authority') {
        console.log("auhtority........");
      if(this.selectedTab === 'Asset' && (this.loggedInUserRole === 'Manager' || this.loggedInUserRole === 'HOD' || this.loggedInUserRole === 'Employee' )){
        
       const userListDataForAssets = (list.users || [])
        .filter((elm: any) => Number(elm.userId) === Number(this.loggedInUserId));

      this.userListDataForAsset = userListDataForAssets.map((elm: any) => ({
        ...elm,
        dateOfAllocation: elm.dateOfAllocation || this.datedisplay,
        employeeCommentDate: elm.employeeCommentDate || this.datedisplay,
        employeeAssetStatus: elm.employeeAssetStatus || "RECEIVED_ASSET"
      }));

      }else{
         const authorityName = this.loggedInUserName; //  Define authority name
          
            // Filter only assets assigned to this authority
            const authorityAssetsMap = this.originalAssets
              .filter(asset => asset.authorityName === authorityName)
              .map(asset => ({
                band: asset.band,
                assetName: asset.assetName
              }));
              
            this.userListDataForAsset = list.users
              .filter((elm: any) =>
                elm.userId === this.updateData.userId &&
                authorityAssetsMap.some(
                  entry => entry.band === elm.band && entry.assetName === elm.assetName
                )
              )
              .map((elm: any) => ({
                ...elm,
                dateOfAllocation: elm.dateOfAllocation ? elm.dateOfAllocation : this.datedisplay,
                employeeCommentDate: elm.employeeCommentDate ? elm.employeeCommentDate : this.datedisplay,
                employeeAssetStatus: elm.employeeAssetStatus ? elm.employeeAssetStatus : "RECEIVED_ASSET"
              }));
          
            //  Set authority-specific dropdowns
            this.dropDownForband = this.userListDataForAsset.map((user: any, index: number) => ({
              id: index,
              band: user.band,
            }));
          
            this.dropDownForEmployee = this.userListDataForAsset.map((user: any) => ({
              userId: user.userId,
              employeName: user.employeeName,
              band: user.band
            }));
          
            this.dropdownData = this.userListDataForAsset.map((user: any, index: number) => ({
              assetId: user.assetId,
              asset: user.assetName,
              employeeName: user.employeeName,
              userId: user.userId
            }));
      }
       
      }
       else if (this.forAuthority === 'From Employee' || 'HR Admin') {
        console.log("employee or hradmin........",this.updateData.userId);
        this.userListDataForAsset = list.users
          .filter((elm: any) => elm.userId === this.updateData.userId)
          .map((elm: any) => ({
            ...elm, // Keep all existing properties of the user object
            dateOfAllocation: elm.dateOfAllocation ? elm.dateOfAllocation : this.datedisplay,
            employeeCommentDate: elm.employeeCommentDate ? elm.employeeCommentDate : this.datedisplay,
            employeeAssetStatus: elm.employeeAssetStatus ? elm.employeeAssetStatus : "RECEIVED_ASSET"
          }));
      }
      
      
      const selectedassetData = this.userListDataForAsset.map((elm: any) => elm.assetId);

      this.selectedAsset = selectedassetData;





    } else {
      this.userListDataForAsset = list
console.log("userlist else--------",  this.userListDataForAsset);

      this.dropDownForband = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
        id: index, // Use a unique identifier (index or user-specific field)
        band: user.band, // Use assetName for the display text
      }));
      this.dropDownForEmployee = this.userListDataForAsset?.users?.map((user: any) => ({
        userId: user.userId, // Use a unique identifier (index or user-specific field)
        employeName: user.employeeName, // Use assetName for the display text
        band: user.band
      }));

  

      this.dropdownData = this.userListDataForAsset?.users?.map((user: any, index: number) => ({
        assetId: user.assetId, // Use a unique identifier (index or user-specific field)
        asset: user.assetName, // Use assetName for the display text
        employeeName: user.employeeName,
        userId: user.userId
      }));


     
    }


  }



  toastShown = false;

  checkMaxLength(comment: string) {
    if (comment?.length === 255 && !this.toastShown) {
      this.toastShown = true;

      this.toastr.error('Maximum limit is 255 characters', 'Limit Reached');

      setTimeout(() => {
        this.toastShown = false;
      }, 3000); // Reset after 3s so it can show again next time
    }
  }



  updateAssetData(index: number) {
    const updatedUser = this.userListDataForAsset[index];
    if (this.findLogdinUserAsaAuthority == 'true' || this.loggedInUserRole == 'HR Admin') {
      this.userListDataForAsset[index].authorityCommentDate = this.todayDate;
    }


    //-----------------------------------------employeeCommentDate---------------------------------------
    let selecteddateemployeeCommentDate = new Date(updatedUser.employeeCommentDate);  // Set the date at midnight
    let date = new Date(selecteddateemployeeCommentDate.getTime() - selecteddateemployeeCommentDate.getTimezoneOffset() * 60000);
    const employeeCommentDate = date.toISOString();

    const existingIndex = this.updatedAssetData.findIndex(
      data => data.id === updatedUser.id
    );

    if (existingIndex === -1) {
      // If not found, add a new object with updated data
      this.updatedAssetData.push({
        id: updatedUser.id,
        // employeeComment: updatedUser.employeeComment,
        // employeeCommentDate: employeeCommentDate,
        // employeeAssetStatus: updatedUser.employeeAssetStatus,
        assetName: updatedUser?.assetName,
        authorityCommentDate: updatedUser?.authorityCommentDate,
        dateOfAllocation: updatedUser?.dateOfAllocation,
        currentAssetDescription: updatedUser?.currentAssetDescription,
        authorityDepartmentComment: updatedUser?.authorityDepartmentComment,


      });
    } else {
      // If found, update the existing object
      this.updatedAssetData[existingIndex] = {
        id: updatedUser.id,
        // employeeComment: updatedUser.employeeComment,
        // employeeCommentDate: employeeCommentDate,
        // employeeAssetStatus: updatedUser.employeeAssetStatus,
        assetName: updatedUser?.assetName,
        authorityCommentDate: updatedUser?.authorityCommentDate,
        dateOfAllocation: updatedUser?.dateOfAllocation,
        currentAssetDescription: updatedUser?.currentAssetDescription,
        authorityDepartmentComment: updatedUser?.authorityDepartmentComment,
      };
    }
  }

 

  updateDataByEmployee() {
    console.log(this.updatedAssetData)
    console.log("userListDataForAsset tab is...", this.userListDataForAsset);
    const apiURL = (this.selectedTab === 'Asset')
      ? this.config.updateByEmployee
      : ((this.findLogdinUserAsaAuthority == 'true' || this.loggedInUserRole === 'HR Admin')
        ? this.config.updateByAuthority
        : this.config.updateByEmployee);
  
  
        const has255CharEmployeeComment = this.userListDataForAsset.some(
          (item: any) => item.employeeComment?.length > 255
        );
      
        const has255CharAssetDescription = this.userListDataForAsset.some(
          (item: any) => item.currentAssetDescription?.length > 255
        );
      
        if (has255CharEmployeeComment || has255CharAssetDescription) {
          return;
        }
  
    //  if no changes made
    if (!this.updatedAssetData || this.updatedAssetData.length === 0) {
        this.toastr.warning('No changes detected', 'Warning'); 
      return;
    }
  
    this.userListDataForAsset.forEach((element: any) => {
      const isUpdated = this.updatedAssetData.find((data: any) => data.id === element.id);
      if (isUpdated) {
        // Convert DD-MM-YYYY → YYYY-MM-DD
        if (element.authorityCommentDate) {
        const [day, month, year] = element.authorityCommentDate.split("-");
        element.authorityCommentDate = `${year}-${month}-${day}`;
        }
        this.httpService.callPutService(apiURL, element).subscribe((result: any) => {
          this.assetAllocationData();
          this.dialogRef.close();
  
          if (result) {
            this.toastr.success(result.message, 'success'); 
          }
        });
      }
    });
  }
  

  cancelData() {
    this.dialogRef.close();
  }
}







// properties declared here 
interface Asset {

  id: any,
  employeeComment: any,
  employeeCommentDate: any,
  authorityCommentDate: any
  employeeAssetStatus: any
  authorityDepartmentComment: string;
}
